import React from 'react';
import { Outlet } from 'react-router';

import cx from './index.module.scss';

interface Props {}

const PlanShareLayout: React.FC<Props> = () => {
  return (
    <div className={cx('PlanShareLayout')}>
      <Outlet />
    </div>
  );
};

export default PlanShareLayout;
